(() => {
  const init = root => {
    if (root.dataset.videosInitialized) return;
    root.dataset.videosInitialized = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const videos = [...root.querySelectorAll('[data-lamp-video]')];
    const states = new Map();
    const load = video => {
      const state = states.get(video);
      if (state.loaded) return;
      state.loaded = true;
      video.src = video.dataset.src;
      video.load();
    };
    const showState = video => {
      const button = states.get(video).button;
      const playing = !video.paused && !video.ended;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? 'Pause lamp video' : 'Play lamp video');
    };
    const play = video => {
      load(video);
      video.muted = true;
      video.play().catch(() => showState(video));
    };
    const sync = () => {
      for (const video of videos) {
        const state = states.get(video);
        if (!state.visible || document.hidden || reduced.matches || state.manualPause) video.pause();
        else play(video);
      }
    };
    videos.forEach(video => {
      const button = video.parentElement.querySelector('[data-video-toggle]');
      states.set(video, {button, visible: false, loaded: false, manualPause: false});
      button.addEventListener('click', () => {
        const state = states.get(video);
        if (!video.paused) {
          state.manualPause = true;
          video.pause();
        } else {
          state.manualPause = false;
          play(video);
        }
      });
      video.addEventListener('play', () => showState(video));
      video.addEventListener('pause', () => showState(video));
      video.addEventListener('error', () => {
        states.get(video).loaded = false;
        showState(video);
      });
    });
    // Observe each video, not its gallery: off-screen slides must not autoplay.
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        states.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio >= 0.45;
      });
      sync();
    }, {threshold: [0, 0.45]});
    videos.forEach(video => observer.observe(video));
    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
  };
  document.querySelectorAll('[data-lamp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-lamp]').forEach(init));
})();
